// extracted by mini-css-extract-plugin
export default {"badge":"UserTypeValueContainer_badge__RLOmF"};